import { createContext, useContext } from 'react';

export type BatchFileListContextType = {
  refreshData: () => void;
};

export const BatchFileListContext = createContext<BatchFileListContextType>({
  refreshData: () => {},
});

export const useBatchFileListContext = (): BatchFileListContextType => {
  const context = useContext(BatchFileListContext);
  if (!context) {
    throw new Error('useBatchFileListContext must be used within a BatchFileListContext.Provider');
  }
  return context;
};
